module.exports = __webpack_public_path__ + "img/dotNet.3950626b.svg";